import {TranslateLoader} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {catchError} from "rxjs/operators";

/**
 * Overwrite the default transaltion laoder because the default has no error handling.
 */
export class TwingleTranslationLoader implements TranslateLoader {
    /**
     * @inheritDoc
     * @param http
     * @param prefix
     * @param suffix
     */
    constructor(private http: HttpClient,
                public prefix: string = "/assets/i18n/",
                public suffix: string = ".json") {}

    /**
     * @inheritDoc
     * @param lang
     */
    public getTranslation(lang: string): Observable<Object> {
        return this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(
            catchError((): Observable<Object> => {
                console.warn("Could not load translations, try again");
                return this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(
                    catchError((): Observable<Object> => {
                        return of({});
                    })
                );
            })
        );
    }
}
